// extracted by mini-css-extract-plugin
export default {"content":"BuyMspPro__content--EB-pL","spacing":"BuyMspPro__spacing--TUtU2","header":"BuyMspPro__header--3L1Ld","title":"BuyMspPro__title--2I-FM"};